<template>
  <div class="rj-page-card">
    <div class="title">
      基础信息
    </div>
    <el-descriptions :column="4">
      <el-descriptions-item label="申请人">
        {{ form.createByName || '-' }}
      </el-descriptions-item>
      <template v-if="isApply">
        <el-descriptions-item label="申请时间">
          {{ dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss') || '-' }}
        </el-descriptions-item>
      </template>
      <template v-else>
        <el-descriptions-item label="申请时间">
          {{ form.applicationTime || '-' }}
        </el-descriptions-item>
      </template>
      <el-descriptions-item label="申请部门">
        {{ form.deptName || '-' }}
      </el-descriptions-item>
      <el-descriptions-item label="订单时间">
        {{ form.orderTime || '-' }}
      </el-descriptions-item>
      <el-descriptions-item label="当前齐套时间">
        {{ form.completeSetTimeBefore || '-' }}
      </el-descriptions-item>
      <el-descriptions-item label="订单类型">
        {{ form.orderTypeName || '-' }}
      </el-descriptions-item>
      <el-descriptions-item label="订单金额（原币）">
        {{ form.orderAmount || '-' }}
      </el-descriptions-item>
      <el-descriptions-item label="客户名称">
        <span :title="form.agentName">
          {{ form.agentName || '-' }}
        </span>
      </el-descriptions-item>
      <el-descriptions-item label="客户类型">
        {{ form.agentType || '-' }}
      </el-descriptions-item>
      <el-descriptions-item label="外销">
        {{ form.saleUserName || '-' }}
      </el-descriptions-item>
      <el-descriptions-item label="国家">
        {{ form.countryName || '-' }}
      </el-descriptions-item>
      <el-descriptions-item label="外销所属区域">
        {{ form.salesRegion || '-' }}
      </el-descriptions-item>
      <el-descriptions-item label="外销所属部门">
        {{ form.salesDeptName || '-' }}
      </el-descriptions-item>
      <el-descriptions-item label="币种">
        {{ form.currencyName || '-' }}
      </el-descriptions-item>
      <el-descriptions-item label="客期变更金额（人民币）">
        {{ tatolCnyValue }}
      </el-descriptions-item>
    </el-descriptions>
  </div>
</template>

<script>
import { deepCopy, numToFixed } from '@/libs/util';
import dayjs from 'dayjs';

export default {
  props: {
    // 是否是重新提交
    isReSubmit: {
      type: Boolean,
      default: false
    },
    // 是否是申请
    isApply: {
      type: Boolean,
      default: false
    },
    tatolCny: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      form: {}
    };
  },
  computed: {
    tatolCnyValue () {
      return numToFixed(this.tatolCny);
    }
  },
  methods: {
    dayjs,
    // 设置默认数据
    setDefaultFormData (data) {
      const { base } = deepCopy(data);
      this.form = base;
    },

    // 向外给出数据 可用于后面扩展
    getFormData () {
      return deepCopy(this.form);
    }
  }
};
</script>

<style lang="scss" scoped>
.title {
  font-size: 14px;
  font-weight: bold;
  color: #383838;
  margin-bottom: 6px;
}
:deep(.el-descriptions-item__content){
  overflow: hidden;
  white-space: nowrap;
  display: block;
  text-overflow: ellipsis;
}
:deep(.el-descriptions-item__cell) {
  font-size: 14px;
  padding: 10px 0;
}
</style>
